import { useCallback } from 'react';
import { useFocalState } from './useFocalState';

// v0.4 Task 11: keyboard-focus → focal turn. Node components attach
// `{...tabTrigger}` to their root so tabbing onto a node lights up
// the turn without scroll or activation; blur only clears if THIS
// node was the source of the tab-focus (otherwise a different
// node's onFocus has already set it).
export function useTabFocalTrigger(turnKey: string | undefined | null) {
  const { setTabFocusTurnId, tabFocusTurnId } = useFocalState();
  const onFocus = useCallback(() => {
    if (turnKey) setTabFocusTurnId(turnKey);
  }, [turnKey, setTabFocusTurnId]);
  const onBlur = useCallback(() => {
    if (tabFocusTurnId === turnKey) setTabFocusTurnId(null);
  }, [turnKey, tabFocusTurnId, setTabFocusTurnId]);
  return { onFocus, onBlur };
}
